import { Header } from "@/components/Header";
import { Sidebar } from "@/components/Sidebar";
import { User } from "../gen/rbt/cloud/v1alpha1/user/user_rbt_react";

interface AppLayoutProps {
  children: React.ReactNode;
  userState: User.State | undefined;
  onSignOut?: () => void;
  organizationIds?: string[];
  currentOrganizationId?: string;
  onOrganizationChange?: (organizationId: string) => void;
}

export function AppLayout({
  children,
  userState,
  onSignOut,
  organizationIds,
  currentOrganizationId,
  onOrganizationChange,
}: AppLayoutProps) {
  return (
    <div className="h-screen bg-background flex flex-col">
      <Header
        userState={userState}
        onSignOut={onSignOut}
        organizationIds={organizationIds}
        currentOrganizationId={currentOrganizationId}
        onOrganizationChange={onOrganizationChange}
      />
      <div className="flex flex-1 min-h-0">
        <Sidebar />
        <main className="flex-1 overflow-auto">
          <div className="w-full flex justify-center">
            <div className="max-w-7xl w-full mx-10 py-8">{children}</div>
          </div>
        </main>
      </div>
    </div>
  );
}
